import Vue from 'vue';
import Vuex from 'vuex';
import student from '@/store/modules/student';
import instructor from '@/store/modules/instructor';
import calendar from '@/store/modules/calendar';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {},

  actions: {},

  mutations: {},

  getters: {},

  modules: {
    student,
    instructor,
    calendar,
  },

  strict: debug,
});
